export type MergeTagOptions = {
  attendeeKeys: string[]
  eventKeys: string[]
  registrationFields: { identifier: string; label?: string }[]
}

const titleize = (key: string) =>
  key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())

export const buildMergeTags = (options?: MergeTagOptions) => {
  if (!options) return {}

  const tags: Record<string, { name: string; value: string }> = {}

  options.attendeeKeys.forEach((key) => {
    const name = `Attendee ${titleize(key)}`
    const mapKey = `attendee_${key}`
    if (!tags[mapKey]) {
      tags[mapKey] = { name, value: `%%attendee.${key}%%` }
    }
  })

  options.registrationFields.forEach((field) => {
    const name = field.label || titleize(field.identifier)
    const mapKey = `attendee_${field.identifier}`
    if (!tags[mapKey]) {
      tags[mapKey] = { name: `Attendee ${name}`, value: `%%attendee.${field.identifier}%%` }
    }
  })

  // Added here rather than arriving in `attendeeKeys`. The server builds that
  // list from VariableRenderer::ATTENDEE_KEYS, which covers plain attributes
  // only — these two resolve to rendered markup instead of a column, so the
  // renderer handles them ahead of that list and they never appear in it.
  // Without this they would be reachable only by typing the tag out by hand.
  if (!tags.attendee_qr) {
    tags.attendee_qr = { name: 'Attendee QR', value: '%%attendee.qr_value%%' }
  }

  if (!tags.attendee_e_cert_link) {
    tags.attendee_e_cert_link = {
      name: 'Attendee E-Cert Link',
      value: '%%attendee.e_cert_link%%',
    }
  }

  options.eventKeys.forEach((key) => {
    const name = `Event ${titleize(key)}`
    const mapKey = `event_${key}`
    if (!tags[mapKey]) {
      tags[mapKey] = { name, value: `%%event.${key}%%` }
    }
  })

  return tags
}

export default buildMergeTags
